import React, { useEffect } from 'react';
import styles from './App.module.css';
import Grain from './components/Grain';
import SystemBar from './components/SystemBar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Meetup from './pages/Meetup';
import Education from './pages/Education';

/**
 * Path-based routing without a router dependency: three static routes,
 * navigated with plain <a> full-page loads. CloudFront's 403/404 → /index.html
 * fallback (status 200) serves the app shell at every path, so deep links to
 * /meetup and /education work with no infra change. Unknown paths render Home.
 */

const TITLES: Record<string, string> = {
  '/meetup': 'Next Meetup — Oak Cliff Tech',
  '/education': 'Community Tech Education — Oak Cliff Tech',
};

function App() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/';

  useEffect(() => {
    document.title = TITLES[path] ?? 'Oak Cliff Tech';
  }, [path]);

  const page =
    path === '/meetup' ? <Meetup /> : path === '/education' ? <Education /> : <Home />;

  return (
    <>
      <Grain />
      <div className={styles.frame}>
        <SystemBar />
        {page}
        <Footer />
      </div>
    </>
  );
}

export default App;
